module.exports = "pegasus_template/assets/theme2/medium/6.jpg";